// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"435c950c","438":"c1e64064","506":"19964cd9","530":"c28a820e","533":"55908345","549":"2d61ec9a","642":"924f00a9","787":"370d19c6","925":"92ba029b"}[chunkId] + ".chunk.js";
};